import React from 'react'
import { Router } from '@reach/router'

import { projectURL } from '../projects'

const Label = ({ label }) => label

const CurrentPageLabel = () => (
  <Router>
    <Label path="/" label="WELCOME" />
    <Label path="/work" label="OUR WORK" />
    <Label path={projectURL('*')} label="OUR WORK" />
    <Label path="/agency" label="OUR AGENCY" />
    <Label path="/playbook" label="OUR PLAYBOOK" />
    <Label path="/blog" label="OUR BLOG" />
    <Label path="/blog/*" label="OUR BLOG" />
    <Label path="/contact" label="YOUR TURN" />
    <Label path="/clients" label="OUR CLIENTS" />
    <Label path="/awards" label="OUR AWARDS" />
    <Label path="/affiliations" label="AFFILIATIONS" />
    <Label default label="PAGE NOT FOUND" />
  </Router>
)

export default CurrentPageLabel
